import React from 'react';

interface MenuSeparatorProps {
  label?: string;
}

export const MenuSeparator: React.FC<MenuSeparatorProps> = ({ label }) => (
  <div className="my-1 border-b border-dark-border/30 relative">
    {label && <span className="absolute -top-2 left-2 bg-dark-surface px-1 text-[9px] text-dark-muted font-bold uppercase">{label}</span>}
  </div>
);
